// Service worker registration helper. Imported once from index.js.
// Skips registration in development by default (CRA hot-reload can collide
// with a service worker). Set REACT_APP_ENABLE_SW=true to force it on locally.

const SW_URL = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
const MANIFEST_URL = `${process.env.PUBLIC_URL || ''}/manifest.json`;

// Ensure the PWA <link rel="manifest"> and Apple-specific meta tags are present
// in the DOM at runtime. We do this defensively because some hosting layers
// strip non-standard tags from the static index.html before serving it.
function ensurePwaTags() {
	if (typeof document === 'undefined') return;
	const head = document.head;
	if (!head) return;

	if (!head.querySelector('link[rel="manifest"]')) {
		const link = document.createElement('link');
		link.rel = 'manifest';
		link.href = MANIFEST_URL;
		head.appendChild(link);
	}

	const metas = [
		{ name: 'mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-capable', content: 'yes' },
		{ name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
		{ name: 'apple-mobile-web-app-title', content: 'MyFamShield' },
		{ name: 'theme-color', content: '#1E3A8A' },
	];
	for (const m of metas) {
		if (!head.querySelector(`meta[name="${m.name}"]`)) {
			const tag = document.createElement('meta');
			tag.name = m.name;
			tag.content = m.content;
			head.appendChild(tag);
		}
	}
}

export function registerServiceWorker() {
	if (typeof window === 'undefined') return;
	ensurePwaTags();
	if (!('serviceWorker' in navigator)) return;

	const isProdLike =
		process.env.NODE_ENV === 'production' ||
		process.env.REACT_APP_ENABLE_SW === 'true';
	if (!isProdLike) return;

	// Register after `load` so it never delays first paint.
	window.addEventListener('load', () => {
		navigator.serviceWorker
			.register(SW_URL)
			.then((reg) => {
				if (process.env.NODE_ENV !== 'production') {
					// eslint-disable-next-line no-console
					console.info('[PWA] Service worker registered:', reg.scope);
				}
				// When a new version is found, prompt it to take over silently.
				reg.addEventListener('updatefound', () => {
					const installing = reg.installing;
					if (!installing) return;
					installing.addEventListener('statechange', () => {
						if (
							installing.state === 'installed' &&
							navigator.serviceWorker.controller
						) {
							installing.postMessage('SKIP_WAITING');
						}
					});
				});
			})
			.catch((err) => {
				// eslint-disable-next-line no-console
				console.warn('[PWA] Service worker registration failed:', err);
			});
	});
}

export function unregisterServiceWorker() {
	if (!('serviceWorker' in navigator)) return;
	navigator.serviceWorker.ready
		.then((reg) => reg.unregister())
		.catch(() => {});
}
